module.exports = __webpack_public_path__ + "img/area-huabei.c9d7f59e.png";